import { render, staticRenderFns } from "./ClientOrdersTable.vue?vue&type=template&id=6ee60edd"
import script from "./ClientOrdersTable.vue?vue&type=script&lang=js"
export * from "./ClientOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./ClientOrdersTable.vue?vue&type=style&index=0&id=6ee60edd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports